import { render, staticRenderFns } from "./PercentageField.vue?vue&type=template&id=24575856"
import script from "./PercentageField.vue?vue&type=script&lang=js"
export * from "./PercentageField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports